import type { ComponentProps } from 'react';

import { Radio } from '@change-corgi/design-system-legacy/components/forms';
import { Box } from '@change-corgi/design-system-legacy/layout';

const radioCardStyles = {
	'&:hover': {
		boxShadow: '0px 6px 12px 0px rgba(0, 0, 0, 0.25)',
		borderRadius: 'standard',
	},
	'& > label': {
		borderRadius: 'standard',
		borderWidth: 1,
		borderColor: 'neutral-grey100',
		borderStyle: 'solid',
		backgroundColor: 'primary-greyBackground',
		display: 'flex',
		flexDirection: 'column-reverse',
		alignItems: 'center',
		'& > input[type="radio"]': {
			margin: 12,
		},
	},
	'& > label:focus-within, & > label[data-selected="true"]': {
		outlineRadius: 'standard',
		outlineWidth: 2,
		outlineStyle: 'solid',
		outlineColor: 'secondary-blue',
	},
	'& > label > input[type="radio"]:focus': {
		outline: 'none',
	},
	'& > label > .boolean-input-label': {
		overflow: 'hidden',
		borderTopRightRadius: 'standard',
		borderTopLeftRadius: 'standard',
		backgroundColor: 'background',
	},
} as const;

export function RadioCard({
	ref,
	...props
}: ComponentProps<typeof Radio> & { ref?: React.RefObject<HTMLInputElement> }): JSX.Element {
	return (
		<Box sx={{ ...radioCardStyles }}>
			<Radio {...props} ref={ref} />
		</Box>
	);
}
